import React from "react";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface ApproveButtonProps {
  langBase: string;
  permission: string | string[];
  isActionAvailable: boolean;
  onApprove: () => void;
}

const ApproveButton: React.FC<ApproveButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onApprove,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="approve-button"
      testId="approve"
      variant="contained"
      startIcon={<ContentPasteGoIcon />}
      onClick={onApprove}
    />
  );
};
export default ApproveButton;
